import { getAlgoliaConfig } from '../algolia/utils';
import { CategoryHandler, CollectionHandler, HomeHandler, SearchFiltersHandler, SearchResultHandler } from '../dla-handlers';
import { SequenceTypes } from '../graphql-orchestrator-link';
const getConfig = config => config;

/**
 * Orchestration configuration for DLA
 *
 * `config` accepts both a config and a function returning config. This can be used for returning
 *  configuration based on some feature flag or some custom logic.
 */

// eslint-disable-next-line max-lines-per-function
const orchestrationEmceeConfig = configProps => {
  const enableV3SearchIndexFlagValue = configProps.statsigClient.enableV3SearchIndex();
  const algoliaConfig = getAlgoliaConfig(configProps.algoliaConfig, enableV3SearchIndexFlagValue);
  const homeHandler = new HomeHandler(algoliaConfig);
  return getConfig({
    GetMarketplaceSearch: {
      config: () => ({
        sequence: SequenceTypes.CUSTOM_ONLY,
        handler: new SearchResultHandler(algoliaConfig, configProps.stargateBaseUrl)
      })
    },
    GetMarketplaceFilters: {
      config: () => ({
        sequence: SequenceTypes.CUSTOM_ONLY,
        handler: new SearchFiltersHandler(configProps.stargateBaseUrl, configProps.statsigClient)
      })
    },
    GetCollection: {
      middlewaresConfig: {
        cache: {
          primary: {
            ttlMs: 60000,
            cacheKey: _ref => {
              let {
                variables
              } = _ref;
              return variables.slug;
            }
          }
        }
      },
      config: () => ({
        sequence: SequenceTypes.PRIMARY_FIRST,
        handler: new CollectionHandler(algoliaConfig)
      })
    },
    GetMarketplaceCategory: {
      middlewaresConfig: {
        cache: {
          primary: {
            ttlMs: 60000,
            // todo: update TTL
            cacheKey: _ref2 => {
              let {
                variables
              } = _ref2;
              return variables.slug;
            }
          }
        }
      },
      config: {
        sequence: SequenceTypes.PRIMARY_FIRST,
        handler: new CategoryHandler(algoliaConfig)
      }
    },
    GetMarketplaceHome: {
      middlewaresConfig: {
        cache: {
          primary: {
            ttlMs: 60000,
            cacheKey: _ref3 => {
              let {
                variables
              } = _ref3;
              return variables.productId;
            }
          }
        }
      },
      config: _ref4 => {
        let {
          variables
        } = _ref4;
        return {
          sequence: variables.first === 1 ? SequenceTypes.CUSTOM_ONLY : SequenceTypes.PRIMARY_FIRST,
          handler: homeHandler
        };
      }
    }
  });
};
export { orchestrationEmceeConfig };